import { render, staticRenderFns } from "./InsightsSummary.vue?vue&type=template&id=aff78700"
import script from "./InsightsSummary.vue?vue&type=script&lang=js"
export * from "./InsightsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports